// extracted by mini-css-extract-plugin
module.exports = {"image--expanded":"ExpandableImage_image--expanded__3oYPH","image":"ExpandableImage_image__2vgGQ"};